import React, { memo, useRef } from "react";
import Typographys from "components/Typographys";

import { Button, Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

const Buttons = props => {
	const {
		children,
		className,
		startIcon,
		endIcon,
		borderradius,
		fontSize,
		colortext,
		backgroundimage,
		backgroundcolor,
		iscenter = false
	} = props;
	const inputRef = useRef(null);

	const getJustifyContent = () => {
		if (!!startIcon) {
			return "flex-start";
		} else {
			if (iscenter) {
				return "center";
			}
			return "space-between";
		}
	};

	const useStyles = makeStyles(
		() =>
			createStyles({
				label: {
					"& > .MuiButton-startIcon": {
						marginLeft: 0
					}
				},
				root: {
					width: "100%",
					height: 40,
					backgroundRepeat: "no-repeat",
					backgroundSize: "100% 120%",
					borderRadius: borderradius ? borderradius : 6,
					backgroundImage: backgroundimage ? backgroundimage : "none"
				}
			}),
		{
			name: "Buttons",
			index: 1
		}
	);

	const classes = useStyles();
	let params = { ...props };
	delete params.iscenter;

	return (
		<Grid
			style={{
				background: backgroundcolor ? backgroundcolor : "",
				borderRadius: borderradius ? borderradius : 6
			}}
		>
			<Button
				{...params}
				className={className}
				ref={inputRef}
				startIcon={startIcon ? startIcon : ""}
				endIcon={endIcon ? endIcon : ""}
				style={{
					justifyContent: getJustifyContent()
				}}
				classes={{ label: classes.label, root: classes.root }}
			>
				<Typographys fontSize={fontSize} colortext={colortext}>
					{children}
				</Typographys>
			</Button>
		</Grid>
	);
};

export default memo(Buttons);
